export default __webpack_public_path__ + "static/img-ei-8-361aaf6d947c89bc41fdd1f93893a6db.png";